// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"64876ffb","811":"bebf7f0b"}[chunkId] + ".chunk.css";
};